// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const WhatsNewIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="WhatsNewIcon" ref={forwardedRef} {...props}>
      <path d="m16 16.5-6.5-3.135V18h-3l-.153-.008A1.5 1.5 0 0 1 5 16.5v-3.536a3.5 3.5 0 0 1 .32-6.96L5.5 6h3.234L16 2.5zm-9.5 0H8V13H6.5zm3-9.204v4.403l5 2.411V4.888zM5.5 7.5a2 2 0 1 0 0 4H8v-4z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const WhatsNewIcon = /* @__PURE__ */ Object.assign(
  WhatsNewIconComponent,
  { displayName: 'WhatsNewIcon' },
);
